import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { SearchInsuranceModel, AddInsuranceModel, getSubscriberDetails, AddSubscriberResponse, SerchInsuranceResponceModel, UpdateInsuranceModel, UpdateSubscriberInfo, PatienT_INSURANCE_INFO, OcrResponce, DeleteInsuranceModel } from 'src/app/models/insurance/inurance';
import { InsurancePhase2Service } from 'src/app/services/insuranceservicephase2/insurance-phase2.service';
import { ConsentForm,insurenacecard,PatientPersonalInfo,VerifypatientModule,Patient_PersonalInfo,madisonPatientRecord, auth } from 'src/app/models/verifypatient/verifypatient';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';

declare var $: any;


@Component({
  selector: 'app-madison-insurance',
  templateUrl: './madison-insurance.component.html',
  styleUrls: ['./madison-insurance.component.css']
})
export class MadisonInsuranceComponent implements OnInit {
  defaultImagefront: any;
  defaultImageback: any;
  getMadisondetails : any;
  patient_Account: any;
  practice_code : any;
  fileArray = Array();
  fileObjFront: any;
  fileObjBack: any;
  loginResp: any = null;
  insurance_card: insurenacecard = new insurenacecard();
  PatientPersonal_Info: PatientPersonalInfo = new PatientPersonalInfo ();

   Madisondetails : madisonPatientRecord = new madisonPatientRecord();
  VerifypatientModule: VerifypatientModule = new VerifypatientModule ();

  patientpersonalinfo :Patient_PersonalInfo = new Patient_PersonalInfo ();
  

   consent_form :ConsentForm = new ConsentForm ();
  constructor(private _insuranceservice: InsurancePhase2Service,private _router: Router,private _VerifypatientService: VerifypatientService, private _phrutilService: PhrutillsService, private _login: ExitingpatientService, private UpdateinfoService: UpdateinfoService,
    private spinner: NgxSpinnerService, private datepipe: DatePipe, private router: Router) { 
    this.defaultImagefront = 'assets/images/card-front.png';
    this.defaultImageback = 'assets/images/card-back.png';


   this.getMadisondetails = this._router.getCurrentNavigation()?.extras.state;

    
     this.patient_Account = this.getMadisondetails.unReadFaxCount.patient_Account;
     this.practice_code = this.getMadisondetails.unReadFaxCount.practice_Code;
    // Madisondetails
    this.Madisondetails.address = this.getMadisondetails.unReadFaxCount.address;
      this.Madisondetails.cell_phone = this.getMadisondetails.unReadFaxCount.cell_phone;
      this.Madisondetails.city = this.getMadisondetails.unReadFaxCount.city;
      this.Madisondetails.date_Of_Birth = this.getMadisondetails.unReadFaxCount.date_Of_Birth;
      this.Madisondetails.first_Name = this.getMadisondetails.unReadFaxCount.first_Name;
      this.Madisondetails.gender = this.getMadisondetails.unReadFaxCount.gender;
      this.Madisondetails.last_Name = this.getMadisondetails.unReadFaxCount.last_Name;
      this.Madisondetails.marital_Status = this.getMadisondetails.unReadFaxCount.marital_Status;
      this.Madisondetails.patient_Account = this.getMadisondetails.unReadFaxCount.patient_Account;
      this.Madisondetails.practice_Code = this.getMadisondetails.unReadFaxCount.practice_Code;
      this.Madisondetails.state = this.getMadisondetails.unReadFaxCount.state;
      this.Madisondetails.zip = this.getMadisondetails.unReadFaxCount.zip;
      this.Madisondetails.email_Address = this.getMadisondetails.unReadFaxCount.email_Address;
  }

  ngOnInit(): void {
  //  this. GetAuth();
  }


  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);

        fileReader.addEventListener('load', (event) => {
          if (type == 'front')
            this.defaultImagefront = event.target?.result;
          else if (type == 'back')
            this.defaultImageback = event.target?.result;
        })
      }
      else{
        $("#isNotValid_format").modal("show");
      }
    }
  }
  onChangeFileFront(event: any) {

        this.fileObjFront = event.target.files[0];
       if (this.fileObjFront)
        {
         this.showPreview(event, 'front');
         event.target.value = '';
       }
       else {
       //  this.isRequireFrontCard = true;
         return;
       }
     }

     CheckType(type:any){

      switch(type){

        case 'primary':
          {
            this.insurance_card.InsuranceType= 'P';
            break;
          }
          case 'secondary':
          {
            this.insurance_card.InsuranceType= 'S';
            break;
          }
          case 'other':
          {
            this.insurance_card.InsuranceType= 'O';
            break;
          }     

      }

     }
     onChangeFileBack(event: any) {
  // let a = type;
       this.fileObjBack = event.target.files[0];
       if (this.fileObjBack) {
         this.showPreview(event, 'back');
       //  this.isRequireBackCard = false;
         event.target.value = '';
       }
       else {
       //  this.isRequireBackCard = true;
         return;
       }
     }
     callOCRinsuranceService() {
     
      if (this.fileObjFront) {
      //  this.isRequireFrontCard = false;
        this.fileArray.push(this.fileObjFront);
      }
      else {
        this._phrutilService.showInfo('Add card front image first.');
       // this.isRequireFrontCard = true;
    //    this.scrollTobuttomandTop(true);
        return;
      }
      if (this.fileObjBack) {
       // this.isRequireBackCard = false;
        this.fileArray.push(this.fileObjBack);
      }
      else {
       // this.scrollTobuttomandTop(false);
       // this.isRequireBackCard = true;
       this._phrutilService.showInfo('Add card back image first.');
        return;
      }
      this.spinner.show();
 
     this.insurance_card.PatientAccount = this.patient_Account;
     this.insurance_card.PracticeCode = this.practice_code;
      this._login.insertSecureDocument(this.fileArray,this.insurance_card).subscribe((res: any) => {
        this.spinner.hide();
      
        if (res && res.statusCode == 200 && res.message.toLowerCase()=='success') {
         
       //  this.router.navigateByUrl("/intake");
          //this.router.navigateByUrl("/patient/intake/allergy");
             $("#ConsentForm1").modal("show");
           
           // this.router.navigateByUrl("/patient/intake/allergy");
          this._phrutilService.showSuccess("Submitted successfully");

        } else {
          this._phrutilService.showError("Some error occured.");
        }
      
           this.fileArray = Array();
           this.defaultImagefront = 'assets/images/card-front.png';
           this.defaultImageback = 'assets/images/card-back.png';
  
      }, (error: any) => {
  
        this.spinner.hide();
        this.fileArray = Array();
        this.defaultImagefront = 'assets/images/card-front.png';
        this.defaultImageback = 'assets/images/card-back.png';
      //  $("#Captured-Modal").modal("hide");
       // $("#incorrectinfoocr-model").modal("show");
       this._phrutilService.showError("Some error occured.");
      });
  
    }


  SignConsent(){
 
    this.spinner.show();

    this.consent_form.isConsent = '1';
    this.consent_form.patientAccount =  this.patient_Account;
    this.consent_form.practiceCode =  this.practice_code;
    this._login.SignConsentForm(this.consent_form).subscribe((res: any) => {
    
      this.spinner.hide();
      if (res && res.statusCode == 200 && res.message.toLowerCase()=='success') {
         $('#ConsentForm1').modal('hide');
            
         this.router.navigateByUrl("/madison-phi")
         //   this.router.navigateByUrl("/madison-ref")
           // this.router.navigateByUrl("/intake");
          //this.router.navigateByUrl("/patient/intake/allergy");
         this._phrutilService.showSuccess("Submitted successfully");
        
         // this.router.navigateByUrl("/intake");
      } else {
        this._phrutilService.showError("Some error occured.");
      }
    }, (error: any) => {
     
      this._phrutilService.showError("Some error occured.");
      this.spinner.hide();
    });

  }

  

}
